<template>
  <div style="padding: 15px">
    <el-form ref="form" :model="form" :rules="isDetail?{}:rules" label-width="150px" :disabled="isDetail">
      <div class="titleh1">
        <code />基本信息
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="用户名称" prop="merchantName">
            <el-input v-model="form.merchantName" clearable :disabled="!isAdd" @focus="selUser()" />
          </el-form-item>
        </el-col>
        <el-col v-if="isAdd" :span="4" style="margin-left:10px;">
          <el-button type="primary" @click="selUser">选择用户</el-button>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商户类型" prop="merchantType">
            <el-select v-model="form.merchantType" placeholder="请选择商户类型" :disabled="!isAdd" @change="getmerchantType">
              <el-option v-for="item in merchantTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="titleh1">
        <code />证件信息
      </div>
      <template v-if="!isDetail">
        <!-- 个人 -->
        <el-row>
          <el-col v-if="form.merchantType == '3'" :span="8">
            <el-form-item prop="certificatePhotoAUrl">
              <ImgUpload :upload-config="{ lebal: '身份证人像面', prefix: 'certificatePhotoAUrl', form: form, suffix: '', modal: false }" />
            </el-form-item>
          </el-col>
          <el-col v-if="form.merchantType == '3'" :span="8">
            <el-form-item prop="certificatePhotoBUrl">
              <ImgUpload :upload-config="{ lebal: '身份证国徽面', prefix: 'certificatePhotoBUrl', form: form, suffix: '', modal: false }" />
            </el-form-item>
          </el-col>

          <el-col v-if="form.merchantType != '3'" :span="8">
            <el-form-item prop="certificatePhotoAUrl">
              <ImgUpload :upload-config="{ lebal: `${name}营业执照`, prefix: 'certificatePhotoAUrl', form: form, suffix: '', modal: false }" />
            </el-form-item>
          </el-col>
          <el-col v-if="form.merchantType != '3'" :span="8">
            <el-form-item prop="lepCertificatePhotoAUrl	">
              <ImgUpload :upload-config="{ lebal:`${name}证件正面`, prefix: 'lepCertificatePhotoAUrl', form: form, suffix: '', modal: false }" />
            </el-form-item>
          </el-col>
          <el-col v-if="form.merchantType != '3'" :span="8">
            <el-form-item prop="lepCertificatePhotoBUrl	">
              <ImgUpload :upload-config="{ lebal:`${name}证件反面`, prefix: 'lepCertificatePhotoBUrl', form: form, suffix: '', modal: false }" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template v-else>
        <el-row>
          <el-col v-if="form.merchantType == '3'" :span="22" :offset="2">
            <ImgReview
              lebal="身份证人像面"
              :src="form.certificatePhotoAUrl"
              error="未上传"
            />
            <ImgReview
              lebal="身份证国徽面"
              :src="form.certificatePhotoBUrl"
              error="未上传"
            />
          </el-col>
          <el-col v-else :span="22" :offset="2">
            <ImgReview
              :lebal="`${name}营业执照`"
              :src="form.certificatePhotoAUrl"
              error="未上传"
            />
            <ImgReview
              :lebal="`${name}证件正面`"
              :src="form.lepCertificatePhotoAUrl"
              error="未上传"
            />
            <ImgReview
              :lebal="`${name}证件反面`"
              :src="form.lepCertificatePhotoBUrl"
              error="未上传"
            />
          </el-col>
        </el-row>
      </template>
      <div class="titleh1">
        <code />详细信息
      </div>
      <!-- 为避免后续修改困难 三种不同类型分开写 -->
      <!-- 自然人 -->
      <el-row v-if="form.merchantType =='3'">
        <el-col :span="8">
          <el-form-item label="商户名称" prop="merchantName">
            <el-input v-model="form.merchantName" clearable placeholder="请输入" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商户简称" prop="merchantShortName">
            <el-input v-model.trim="form.merchantShortName" :maxlength="32" clearable placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话" prop="contactPhone">
            <el-input v-model.trim="form.contactPhone" :maxlength="11" clearable placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商户证件类型" prop="certificateType">
            <el-select v-model="form.certificateType" placeholder="请选择商户证件类型">
              <el-option v-for="item in parentData.certificateTypeOptions" :key="item.code" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="证件号码" prop="certificateNumber">
            <el-input v-model.trim="form.certificateNumber" :maxlength="20" clearable placeholder="请输入证件号码" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 个体商户信息  -->
      <el-row v-if="form.merchantType !='3'">
        <el-col :span="8">
          <el-form-item label="商户名称" prop="merchantName">
            <el-input v-model="form.merchantName" clearable placeholder="请输入" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商户简称" prop="merchantShortName">
            <el-input v-model.trim="form.merchantShortName" :maxlength="32" clearable placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商户证件类型" prop="certificateType">
            <el-select v-model="form.certificateType" placeholder="请选择商户证件类型">
              <el-option v-for="item in parentData.certificateTypeOptions" :key="item.code" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="form.merchantType=='1'?'企业证件号码':'商户证件号码'" prop="certificateNumber">
            <el-input v-model.trim="form.certificateNumber" :maxlength="20" clearable placeholder="请输入商户证件号码" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 此处通用 自然人 商户 企业 -->
      <el-row>
        <!-- 商户证件开始日期 -->
        <el-col :span="12">
          <el-form-item label="商户证件开始日期" prop="certificateValidityBegin">
            <el-date-picker
              v-model="form.certificateValidityBegin"
              type="date"
              placeholder="请选择商户证件开始日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="商户证件有效期" prop="certificateValidityEnd">
            <el-date-picker
              v-model="form.certificateValidityEnd"
              :class="form.hasDueDate?'disabledhide':''"
              type="date"
              placeholder="请选择商户证件有效期"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox v-model="form.hasDueDate" @change="(value)=>{this.$set(form,'certificateValidityEnd' , value?'2999-12-31':'');}" />
          </el-form-item>
        </el-col>
        <!-- 常住地址 -->
        <el-col :span="12">
          <el-form-item :label="form.merchantType?addressObj[form.merchantType]:'企业地址'" prop="areaList">
            <el-cascader
              v-model="form.areaList"
              :options="areaOptions"
              :props="{ value: 'countyCode', label: 'countyName', children: 'children' }"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址" prop="address">
            <el-input v-model.trim="form.address" :maxlength="90" clearable placeholder="请输入详细地址" />
          </el-form-item>
        </el-col>
        <!-- 新增邮箱 -->
        <el-col :span="24">
          <el-form-item label="邮箱" prop="contactMail">
            <el-input v-model.trim="form.contactMail" :maxlength="28" clearable placeholder="请输入邮箱" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 之后只有商户与企业 -->
      <el-row v-if="form.merchantType !='3'">
        <!-- 新增经营者或法人信息 -->
        <el-col :span="8">
          <el-form-item prop="lepName">
            <span slot="label">{{ name }}姓名</span>
            <el-input v-model.trim="form.lepName" :maxlength="18" clearable placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="lepPhone">
            <span slot="label">{{ name }}手机</span>
            <el-input v-model.trim="form.lepPhone" :maxlength="11" clearable placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="form.merchantType =='1'?'法人证件类型':'经营者证件类型'" prop="lepCertificateType">
            <el-select v-model="form.lepCertificateType" placeholder="请选择">
              <el-option v-for="item in parentData.certificateTypeOptions" :key="item.code" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item prop="lepCertificateNumber">
            <span slot="label">{{ name }}证件号</span>
            <el-input v-model.trim="form.lepCertificateNumber" :maxlength="18" clearable placeholder="请输入" />
          </el-form-item>
        </el-col>
        <!-- 法人证件开始日期 -->
        <el-col :span="12">
          <el-form-item :label="form.merchantType=='1'?'法人证件开始日期':'企业证件开始日期'" prop="lepCertificateValidityBegin">
            <el-date-picker v-model="form.lepCertificateValidityBegin" type="date" :placeholder="form.merchantType=='1'?'请选择法人证件开始日期':'请选择企业证件开始日期'" value-format="yyyy-MM-dd" clearable :picker-options="pickerOptions" />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item :label="form.merchantType=='1'?'法人证件有效期':'企业证件有效期'" prop="lepCertificateValidityEnd">
            <el-date-picker
              v-model="form.lepCertificateValidityEnd"
              :class="form.hasLepCertificateDueDate?'disabledhide':''"
              type="date"
              :placeholder="form.merchantType=='1'?'请选择法人证件有效期':'请选择企业证件有效期'"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasLepCertificateDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox v-model="form.hasLepCertificateDueDate" @change="(value)=>{this.$set(form,'lepCertificateValidityEnd' , value?'2999-12-31':'');}" />
          </el-form-item>
        </el-col>
        <!-- 法人地址 -->
        <el-col v-if="form.merchantType=='1'" :span="24">
          <el-form-item label="法人地址" prop="lepAddress">
            <el-input v-model.trim="form.lepAddress" :maxlength="90" clearable placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <!-- 账户信息通用 -->
        <div class="titleh1">
          <code />账户信息
        </div>
        <el-row>
          <el-col :span="8">
            <el-form-item label="账户类型" prop="cardAccType">
              <el-select v-model="form.cardAccType" placeholder="请选择银行卡类型" disabled>
                <el-option label="个人账户" :value="1" />
                <el-option label="企业账户" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="银行卡类型" prop="cardType">
              <el-select v-model="form.cardType" placeholder="请选择银行卡类型" disabled>
                <el-option label="基本户" :value="1" />
                <el-option label="一般户" :value="2" />
                <el-option label="借记卡" :value="3" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开户银行" prop="bankName">
              <el-select v-model="form.bankName" placeholder="请选择" clearable filterable disabled>
                <el-option v-for="item in parentData.bankList" :key="item.code" :label="item.name" :value="item.code" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开户支行" prop="bankChildName">
              <el-input v-model="form.bankChildName" clearable placeholder="请输入开户支行" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="预留手机号" prop="cardBankPhone">
              <el-input v-model.trim="form.cardBankPhone" :maxlength="11" clearable placeholder="请输入联行号" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="银行卡号" prop="cardNumber">
              <el-input v-model="form.cardNumber" clearable placeholder="请输入银行卡号" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <div style="text-align:center">
          <el-button type="primary" @click="confirm('form')">确定</el-button>
          <el-button @click="cancel('form')">取消</el-button>
        </div>
      </el-row>
    </el-form>
    <vxe-modal v-model="vardel" width="900" height="auto" title="选择用户" resize>
      <Selectuser v-if="vardel" ref="ShipperlRef" @event1="receive" />
    </vxe-modal>
  </div>
</template>
<script>
import { arpaMerchant, getArpaMerchant } from '@/api/merchantCenter'
import { isEmail } from '@/utils/validate4Form'
import { bigAreaCity, bigAreaCounty } from '@/api/InternetBanking'

import ImgUpload from '@/components/ImgUpload'
import ImgReview from "@/components/ImgReview"
import Selectuser from './components/Selectuser.vue'
import { SelectAddress } from '@/api/components'
export default {
  name: 'MerchantManagementEdit',
  components: {
    ImgUpload,
    Selectuser,
    ImgReview
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false
        }
      }
    }
  },
  data() {
    return {
      pickerOptions:{
        disabledDate:(time)=> {
          return time.getTime() >= Date.now()
        }
      },
      statusdisabled: false,
      vardel: false,
      name: '法人',
      form: {
        partyCode:'',
        merchantName: '',
        merchantType: '',
        certificatePhotoAUrl: '',
        certificatePhotoBUrl: '',
        lepCertificatePhotoAUrl:'',
        lepCertificatePhotoBUrl:'',
        merchantShortName: '',
        certificateType:'',
        contactPhone: '',
        corporateNoType: '',
        certificateNumber:'',
        certificateValidityBegin: '',
        certificateValidityEnd: '',
        hasDueDate: false,
        areaList: [],
        address:'',
        contactMail:'',
        lepName:'',
        lepPhone:'',
        lepCertificateType:'',
        lepCertificateNumber:'',
        lepCertificateValidityBegin:'',
        lepCertificateValidityEnd:'',
        hasLepCertificateDueDate: false,
        lepAddress:'',
        cardAccType:'',
        bankName:'',
        cardType:'',
        bankChildName:'',
        cardBankPhone:'',
        cardNumber: '',
      },
      emptyForm: {},
      addressObj: { 1: '企业地址', 2: '经营地址', 3: '常住地址' },
      // 省市县地址
      areaOptions: [],
      cityList: [],
      districtList: [],
      provinceList: [],
      merchantTypeOptions: [
        {
          value: '1',
          label: '企业商户'
        },
        {
          value: '2',
          label: '个体商户'
        },
        {
          value: '3',
          label: '自然人'
        }
      ],
      rules: {
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        merchantName: [
          { required: true, message: '请输入商户名称', trigger: 'change' }
        ],
        merchantType: [
          { required: true, message: '请选择商户类型', trigger: 'blur' }
        ],
        areaList: [{ required: true, message: '请选择地址', trigger: 'blur' }],
        city: [{ required: true, message: '请选择市', trigger: 'blur' }],
        province: [{ required: true, message: '请选择省份', trigger: 'blur' }],
        county: [{ required: true, message: '请选择县区', trigger: 'blur' }],
        lepCertificateValidityEnd: [
          { required: true, message: `请选择法人有效期` }
        ],
        lepCertificateValidityBegin: [
          { required: true, message: `请选择法人开始日期`, trigger: 'blur' }
        ],
        certificateValidityEnd: [
          {
            required: true,
            message: `请选择商户证件有效期`
          }
        ],
        certificateValidityBegin: [
          { required: true, message: `请选择商户证件开始日期`, trigger: 'blur' }
        ],
        certificateNumber: [
          { required: true, message: '请输入商户证件号码', trigger: 'blur' }
        ],
        lepCertificateNumber: [
          {
            required: true,
            message: '请输入法人/经营者证件号码',
            trigger: 'blur'
          }
        ],
        lepCertificateType: [
          { required: true, message: `请选择法人证件类型`, trigger: 'change' }
        ],
        lepPhone: [
          { required: true, message: `请输入法人手机号`, trigger: 'blur' }
        ],
        lepName: [
          { required: true, message: `请输入法人姓名`, trigger: 'blur' }
        ],
        lepAddress: [
          { required: true, message: `请输入法人地址`, trigger: 'blur' }
        ],
        merchantShortName: [
          { required: true, message: '请输入商户简称', trigger: 'blur' }
        ],
        certificateType: [
          { required: true, message: '请选择证件类型', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        corporateNoType: [
          { required: true, message: '请选择法人证件类型', trigger: 'blur' }
        ],
        cardAccType: [
          { required: true, message: '账号类型不能为空', trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: '开户银行不能为空', trigger: 'blur' }
        ],
        cardType: [
          { required: true, message: '银行卡类型不能为空', trigger: 'blur' }
        ],

        bankChildName: [
          { required: true, message: '开户支行不能为空', trigger: 'blur' }
        ],
        cardBankPhone: [
          { required: true, message: '预留手机号不能为空', trigger: 'blur' }
        ],
        cardNumber: [
          { required: true, message: '银行卡号不能为空', trigger: 'blur' }
        ],
        contactMail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: isEmail, trigger: 'blur' }
        ]
      },
      certificatePhotoAUrl:'',// 单独存一下营业执照照片信息
    }
  },
  computed: {
    compMerchantType() {
      return this.form.merchantType
    },
    compMerchantName() {
      return this.form.merchantName
    },
    isAdd() {
      return this.parentData.model === 'Add' ? true : false
    },
    isDetail() {
      return this.parentData.model === 'Detail'
    }
  },
  watch: {
    compMerchantType(n) {
      const name = n == 1 ? '法人' : '经营者'
      this.rules.lepCertificateValidityEnd[0].message = `请选择${name}有效期`
      this.rules.lepCertificateValidityBegin[0].message = `请选择${name}开始日期`
      this.rules.lepCertificateType[0].message = `请选择${name}证件类型`
      this.rules.lepPhone[0].message = `请选择${name}手机号`
      this.rules.lepName[0].message = `请选择${name}姓名`
      this.rules.lepAddress[0].message = `请选择${name}地址`
      if(n == '3') {
        this.form.lepCertificatePhotoAUrl = ""
        this.form.lepCertificatePhotoBUrl = ""
      } else {
        this.form.certificatePhotoBUrl = ""
      }
    },
    compMerchantName(newVal) {
      if(!newVal){
        this.merchantTypeOptions = [
          {
            value: '1',
            label: '企业商户'
          },
          {
            value: '2',
            label: '个体商户'
          },
          {
            value: '3',
            label: '自然人'
          }
        ]
      }
    }
  },
  created() {
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
    this.bigProvince()
  },
  methods: {
    // 获取详情
    MerchantEditor(merchantId, prefix) {
      // this.form = JSON.parse(JSON.stringify(this.emptyForm))
      // this.$refs.form.clearValidate()
      if(merchantId) {
        const rLoading = this.openLoading()
        getArpaMerchant(merchantId, prefix).then((response) => {
          this.form = response.data
          this.$set(
            this.form,
            'hasDueDate',
            this.form.certificateValidityEnd == '9999-12-31'
          )
          this.$set(
            this.form,
            'hasLepCertificateDueDate',
            this.form.lepCertificateValidityEnd == '9999-12-31'
          )
          rLoading.close()
        })
      }
    },
    getmerchantType($event) {
      this.$refs.form.clearValidate()
      this.name = $event == 1 ? '法人' : '经营者'
      this.$forceUpdate();
    },
    cancel() {
      this.$emit('merchantClose', false)
    },

    confirm(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          // 商户证件日期校验
          if (new Date(this.form.certificateValidityEnd) < new Date(this.form.certificateValidityBegin)) {
            this.$message.warning("商户证件有效期不能小于开始日期，请重新选择");
            return false
          }
          // 法人证件、企业证件日期校验
          if (new Date(this.form.lepCertificateValidityEnd) < new Date(this.form.lepCertificateValidityBegin)) {
            const title = this.form.merchantType == '1' ? '法人证件' : '企业证件'
            this.$message.warning(title + "有效期不能小于开始日期，请重新选择");
            return false
          }
          if(this.form.areaList.length===0){
            return false;
          }
          const rLoading = this.openLoading()
          let response = this.isAdd
          ? await arpaMerchant(this.form, 'post')
          : await arpaMerchant(this.form, 'put')
          this.$message({ message: response.msg, type: 'success' })
          this.$emit('merchantClose',true)
          rLoading.close()
        } else {
          return false
        }
      })
    },
    // 重置
    onReset() {
      // this.form = JSON.parse(JSON.stringify(this.emptyForm))
      // this.$nextTick(() => {
        this.$refs.form.resetFields()
        this.form.certificatePhotoAUrl = ""
        this.form.certificateValidityEnd = ""
        this.form.areaList = ""
        this.form.address = ""
      // })
    },
    selUser() {
      this.vardel = true
    },
    receive(data) {
      this.vardel = false
      this.certificatePhotoAUrl = '' // 切换用户，清除之前的营业执照图片
      this.form = data
      if(!Array.isArray(this.form.areaList)) {
        this.form.areaList = []
      }
      this.$set(
        this.form,
        'hasDueDate',
        this.form.certificateValidityEnd == '9999-12-31'
      )
      this.$set(
        this.form,
        'hasLepCertificateDueDate',
        this.form.lepCertificateValidityEnd == '9999-12-31'
      )
      //3- 自然人 2 个体商户 1-企业法人
      if (
        this.form.partyType == 'SHIPMENT' || this.form.partyType == 'DRIVER_LEADER'
      ) {
        this.merchantTypeOptions = [
          {
            value: '1',
            label: '企业商户'
          },
          {
            value: '2',
            label: '个体商户'
          },
          {
            value: '3',
            label: '自然人'
          }
        ]
      } else if (this.form.partyType == 'DRIVER') {
        this.merchantTypeOptions = [
          {
            value: '2',
            label: '个体商户'
          },
          {
            value: '3',
            label: '自然人'
          }
        ]
      } else {
        this.merchantTypeOptions = [
          {
            value: '1',
            label: '企业商户'
          }
        ]
      }
      // this.cityChange(data.province);
      // this.districtChage(data.city);
    },
    //省
    bigProvince() {
      // 省市县
      SelectAddress().then((response) => {
        this.areaOptions = response.data.records
      })
    },
    //市
    cityChange(a) {
      bigAreaCity({ provinceCode: a }).then((response) => {
        this.cityList = response.data.records
      })
    },
    districtChage(b) {
      bigAreaCounty({ cityCode: b }).then((response) => {
        this.districtList = response.data.records
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;

  code {
    width: 5px;
    height: 20px;
    background-color: #ff7f21;
    float: left;
    margin-right: 5px;
    margin-top: 13px;
  }
}
</style>
